export enum FilterObjectType {
  SELECT = 'select',
  SELECT_FIXED = 'select_fixed',
	SELECT_RADIO = 'select_radio',
  RANGE = 'range',
  CUSTOM = 'custom'
}
